/**
 * DescriptionContentContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled description content container.
 */
const DescriptionContainer = styled.div.attrs({
  id: 'descriptionContainer',
})`
  display: flex;
  flex-direction: column;
  height: ${525 * Screen.widthRatio}px;
  left: ${120 * Screen.widthRatio}px;
  max-width: ${1020 * Screen.widthRatio}px;
  pointer-events: none;
  position: absolute;
  top: ${54 * Screen.widthRatio}px;
  width: 100%;
  z-index: 1;
`;

export default withOpacity(DescriptionContainer);
